<style scoped>
  .grouping{font-size: 14px;color: #464c5b;line-height: 60px;height: 60px;font-weight: bold;text-align: center;border-bottom: 1px solid #d7dde4;}
  .grouping-content{font-size: 14px;color: #464c5b;line-height: 60px;height: 60px;text-align: center;border-bottom: 1px solid #d7dde4;}
</style>

<template>
  <div class="group">
    <Row class="grouping">
      <Col span="12">分组名称</Col>
      <Col span="12">操作</Col>
    </Row>
    <Row class="grouping-content">
      <Col span="12">律师</Col>
      <Col span="12" style="color: #00a2e9;">分配权限</Col>
    </Row>
  </div>
</template>
<script>
  export default {
    name: "project",//项目权限
    data:function () {
      return{

      }
    },
    mounted:function () {

    },
    methods:{
      getList:function () {
        var _this = this
        _this.send({
          headers:"P/PurviewList",

        })
      }
    }
  }
</script>


